export default __webpack_public_path__ + "static/media/Group9262.c1b67561.svg";